import { makeAutoObservable } from 'mobx'
import { ShopRootStore } from 'shop/stores/shopRoot.store'
import { STIPE_ELEMENT_OPTIONS_DEFAULT } from 'constants/paymentSettingShared.constants'

import { StripeElementsOptionsMode } from 'shop/types/stripe'
import { StripePaymentElement } from '../../interfaces/payment-method-interfaces/StripePaymentMethod'

export class ShopIdealPaymentMethodStore implements StripePaymentElement {
  storeName = 'shopIdealPaymentMethodStore'
  root: ShopRootStore = null

  constructor(root: ShopRootStore) {
    this.root = root

    makeAutoObservable(this)
  }

  getStripeElementPayload = ({
    isDealsPage,
    isManagePage,
  }: {
    isDealsPage: boolean
    isManagePage: boolean
  }): StripeElementsOptionsMode => {
    if (isDealsPage) {
      return (
        (this.root.dealsStore?.getIdealStripeElementPayload && this.root.dealsStore.getIdealStripeElementPayload()) ||
        STIPE_ELEMENT_OPTIONS_DEFAULT
      )
    } else if (isManagePage) {
      return (
        (this.root.ordersStore?.getIdealStripeElementPayload && this.root.ordersStore.getIdealStripeElementPayload()) ||
        STIPE_ELEMENT_OPTIONS_DEFAULT
      )
    } else {
      return (
        (this.root.paymentStore?.getIdealStripeElementPayload &&
          this.root.paymentStore.getIdealStripeElementPayload()) ||
        STIPE_ELEMENT_OPTIONS_DEFAULT
      )
    }
  }
}
